export enum LocalStorageKeyEnum {
  SIDE_SHEET_SLOT_WIDTH = "pico:sideSheetSlotWidth",
}
